import { memo } from 'motion-utils';

const supportsScrollTimeline = memo(() => window.ScrollTimeline !== undefined);

export { supportsScrollTimeline };
